export default "__VITE_ASSET__k3a$eYBr__"